const eventMap = {};

function register(controller, methods) {
    eventMap[controller] = methods;
}

export {eventMap, register};
